import { render, staticRenderFns } from "./new_fiat2.vue?vue&type=template&id=2d0db0ca&scoped=true"
import script from "./new_fiat2.vue?vue&type=script&lang=js"
export * from "./new_fiat2.vue?vue&type=script&lang=js"
import style0 from "./new_fiat2.vue?vue&type=style&index=0&id=2d0db0ca&prod&scoped=true&lang=css"
import style1 from "./new_fiat2.vue?vue&type=style&index=1&id=2d0db0ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0db0ca",
  null
  
)

export default component.exports